import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom"; // React Router Link 사용
import IonIcon from "../components/IonIcon";

const Header = ({ handleLogout }) => {
  const [currentDate, setCurrentDate] = useState(""); // 년월일
  const [currentTime, setCurrentTime] = useState(""); // 시분초
  const location = useLocation();

  const formatDateTime = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return {
      date: `${year}년 ${month}월 ${day}일`,
      time: `${hours}:${minutes}:${seconds}`,
    };
  };

  useEffect(() => {
    const now = new Date();
    const { date, time } = formatDateTime(now);
    setCurrentDate(date);
    setCurrentTime(time);

    const interval = setInterval(() => {
      const updatedTime = new Date();
      const { date, time } = formatDateTime(updatedTime);
      setCurrentDate(date);
      setCurrentTime(time);
    }, 1000);

    return () => clearInterval(interval); // 컴포넌트 언마운트 시 정리
  }, []);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <header className="header">
      <div className="logobox">
        <img
          src={require("../images/logo_w.png")}
          alt="스마트 안전감시 시스템 로고"
        />
        <span>스마트 안전감시 시스템</span>
      </div>
      <div className="navbox">
        <ul>
          {/* <NavLink
            to="/dashboard"
            className={isActive("/dashboard") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault(); // 기본 네비게이션 방지
              window.open("/dashboard", "_blank", "noopener,noreferrer");
            }}
          >
            <IonIcon
              name={isActive("/dashboard") ? "IoGrid" : "IoGridOutline"}
              size={24}
            />{" "}
            대시보드
          </NavLink> */}

          <NavLink
            to="/dashboard/location"
            className={isActive("/dashboard/location") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/dashboard/location";
            }}
          >
            <IonIcon
              name={
                isActive("/dashboard/location")
                  ? "IoLocation"
                  : "IoLocationOutline"
              }
              size={24}
            />{" "}
            위치관제
          </NavLink>
          <NavLink
            to="/beacons/management"
            className={isActive("/beacons/management") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/beacons/management";
            }}
          >
            <IonIcon
              name={
                isActive("/beacons/management") ? "IoCreate" : "IoCreateOutline"
              }
              size={24}
            />{" "}
            비콘관리
          </NavLink>
          <NavLink
            to="/dashboard"
            className={isActive("/dashboard") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/dashboard";
            }}
          >
            <IonIcon
              name={isActive("/dashboard") ? "IoGrid" : "IoGridOutline"}
              size={24}
            />{" "}
            대시보드
          </NavLink>

          {/* <NavLink
            to="/integratedcontrol"
            className={isActive("/integratedcontrol") ? "on" : ""}
          >
            <IonIcon
              name={
                isActive("/integratedcontrol")
                  ? "IoAnalytics"
                  : "IoAnalyticsOutline"
              }
              size={24}
            />{" "}
            통합관제
          </NavLink> */}
          <NavLink
            to="/realtimevideo"
            className={isActive("/realtimevideo") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/realtimevideo";
            }}
          >
            <IonIcon
              name={
                isActive("/realtimevideo") ? "IoVideocam" : "IoVideocamOutline"
              }
              size={24}
            />{" "}
            실시간영상
          </NavLink>
          <NavLink
            to="/recordingvideo"
            className={isActive("/recordingvideo") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/recordingvideo";
            }}
          >
            <IonIcon
              name={isActive("/recordingvideo") ? "IoFilm" : "IoFilmOutline"}
              size={24}
            />{" "}
            녹화영상
          </NavLink>
          <NavLink
            to="/entryexit"
            className={isActive("/entryexit") ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/entryexit";
            }}
          >
            <IonIcon
              name={isActive("/entryexit") ? "IoPeople" : "IoPeopleOutline"}
              size={24}
            />
            출입자관리
          </NavLink>
          {/* <NavLink
            to="/facilitymonitoring"
            className={isActive("/facilitymonitoring") ? "on" : ""}
          >
            <IonIcon
              name={
                isActive("/facilitymonitoring")
                  ? "IoHardwareChip"
                  : "IoHardwareChipOutline"
              }
              size={24}
            />{" "}
            설비감시
          </NavLink> */}
          <NavLink to="/event" className={isActive("/event") ? "on" : ""}>
            <IonIcon
              name={
                isActive("/event")
                  ? "IoNotifications"
                  : "IoNotificationsOutline"
              }
              size={24}
            />{" "}
            이벤트
          </NavLink>
          {/* <NavLink
            to="/management"
            className={isActive("/management") ? "on" : ""}
          >
            <IonIcon
              name={
                isActive("/management") ? "IoSettings" : "IoSettingsOutline"
              }
              size={24}
            />{" "}
            관리
          </NavLink> */}
        </ul>
      </div>
      <div className="watchbox">
        <div className="date">{currentDate}</div>
        <div className="time">{currentTime}</div>
        <button onClick={handleLogout} className="logoutbtn">
          <IonIcon name="IoLogOutOutline" size={24} />
        </button>
      </div>
    </header>
  );
};

export default Header;
